import Box from "@mui/material/Box";
import { Grid, Typography, Stack, Divider, Paper } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const GeneralWithCategoriesForm = ({
  generalServices,
  isGeneralCategoryForm,
}) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          {" "}
          تفاصيل الطلب{" "}
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
          {isGeneralCategoryForm && (
            <Grid item md={3} sm={4} xs={12}>
              <Stack direction={"row"} gap={1}>
                <Typography sx={{ fontWeight: "bold" }}> تصنيف الطلب:</Typography>
                <Typography>{generalServices?.generalCategory?.name}</Typography>
              </Stack>
            </Grid>
          )}
          <Grid item md={isGeneralCategoryForm ? 9 : 12} sm={isGeneralCategoryForm ? 8 : 12} xs={12}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>التفاصيل:</Typography>
            <Typography 
              component="div"
              sx={{ 
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                backgroundColor: "#f5f5f5",
                minHeight: "56px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {generalServices.notes || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default GeneralWithCategoriesForm;
